import React from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';
import Immutable from 'immutable';

import {
  Menu,
} from '@uncinc/react-drupal-core';
import { Button } from '@uncinc/uncinc-react-kitchen-sink';

import { ZENCHEF_CLASSES } from '../../../config/constants';

import './style.scss';

// menu for extra two buttons
const MenuSecondary = ({ setOverlayMenuVisible, id }) => {
  const currentPage = useSelector((state) => state.getIn(['router', 'location', 'pathname'], ''));

  return (
    <Menu id={id || 'main-cta'}>
      {(items) => {
        return (
          <>
            {items.map((item, index) => {
              if (item) {
                const title = item.getIn(['link', 'title'], 'Untitled');
                const url = item.getIn(['link', 'url'], '');
                const active = item.getIn(['link', 'url']) === currentPage;
                const isCta = index === 1;
                const SecondaryMenuItemClassnames = c('SecondaryMenu__item', {
                  'SecondaryMenu__item--active': active,
                });
                const linkClasses = item.getIn(['link', 'options', 'attributes', 'class'], Immutable.List()).toJS();
                const linkClassNames = c('SecondaryMenu__item__link', linkClasses, {
                  'Button--cta': isCta,
                  'Button--secondary': index > 0,
                });

                return (
                  <div key={title} className={SecondaryMenuItemClassnames}>
                    <Button
                      href={url.match(/<nolink>/) === null ? url : ''}
                      className={linkClassNames}
                      {...(linkClasses?.[0] && linkClasses[0].includes(ZENCHEF_CLASSES.OPEN)) ? {
                        'data-zc-action': 'open',
                      } : {
                        onClick: () => setOverlayMenuVisible(false),
                      }}
                    >
                      <span className="SecondaryMenu__item__title">{title}</span>
                    </Button>
                  </div>
                );
              }
            })}
          </>
        );
      }}
    </Menu>
  );
};

export default MenuSecondary;
